import { useState } from "react";
import { FileText, ShieldCheck, Loader2 } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "../ui/sheet";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const LICENSES = [
  "Разрешение на обработку фискальных данных",
  "Лицензия на осуществление разработки, производства, распространения шифровальных (криптографических) средств",
  "Протокол проверки функциональной совместимости",
  "Уведомление о положительном результате проведения проверки функциональной совместимости ПО",
  "Лицензия на деятельность по технической защите конфиденциальной информации",
  "Паспорт о присоединении к сети ДОЭД счетов-фактур",
  "Аттестат соответствия требованиям безопасности информации",
  "Сертификат соответствия системы КРИПТОДОК требованиям нормативных документов Росстандарта",
  "Свидетельство на товарный знак",
  "Выписка из реестра аккредитованных IT-компаний",
  "Декларация о соответствии EAC модели ККТ Эфир Pro ФС/ФА",
];

export function LandingLicensesSheet() {
  const [open, setOpen] = useState(false);
  const [viewingTitle, setViewingTitle] = useState(null);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="hover:text-slate-900 flex items-center gap-1.5"
        data-testid="landing-footer-licenses-trigger"
      >
        <ShieldCheck className="w-3.5 h-3.5" />
        Лицензии
      </button>
      <SheetContent side="bottom" className="max-h-[80vh] overflow-y-auto" data-testid="licenses-sheet">
        <SheetHeader>
          <SheetTitle>Лицензии</SheetTitle>
          <SheetDescription>
            Документы и разрешения, подтверждающие соответствие КриптоДок требованиям законодательства.
          </SheetDescription>
        </SheetHeader>
        <ul className="mt-4 divide-y divide-slate-100" data-testid="licenses-list">
          {LICENSES.map((title, i) => (
            <li key={i}>
              <button
                type="button"
                onClick={() => setViewingTitle(title)}
                className="w-full flex items-center gap-3 py-3.5 text-sm text-slate-700 text-left hover:bg-slate-50 rounded-lg px-2 -mx-2 transition-colors"
                data-testid={`licenses-item-${i}`}
              >
                <FileText className="w-4 h-4 text-[#4E9BEE] shrink-0" />
                {title}
              </button>
            </li>
          ))}
        </ul>
      </SheetContent>

      <Dialog open={!!viewingTitle} onOpenChange={(v) => !v && setViewingTitle(null)}>
        <DialogContent className="sm:max-w-md" data-testid="license-photo-loading-overlay">
          <DialogHeader>
            <DialogTitle className="pr-4">{viewingTitle}</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col items-center text-center gap-4 py-6">
            <Loader2 className="w-10 h-10 text-[#4E9BEE] animate-spin" data-testid="license-photo-loading-spinner" />
            <p className="text-xs text-slate-400">Загружаем скан документа из облака…</p>
          </div>
        </DialogContent>
      </Dialog>
    </Sheet>
  );
}


